import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
  // Category1,
  // Category2,
  // Category3,
  // Category4,
  // Category5,
  // Category6
} from "../assets/images/index";

// =================== NavBarList Start here ====================
export const navBarList = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
  },
  {
    _id: 1002,
    title: "Shop",
    link: "/shop",
  },
];
// =================== NavBarList End here ======================
// =================== Special Offer data Start here ============
export const SplOfferData = [
  {
    _id: "201",
    img: spfOne,
    productName: "MSI NB GS65",
    price: "300.00",
    color: "Black and White",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: "202",
    img: spfTwo,
    productName: "Poco X5",
    price: "150.00",
    color: "Black, Yellow, Blue",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: "203",
    img: spfThree,
    productName: "Headphones",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: "204",
    img: spfFour,
    productName: "ROG Zephyrus G14",
    price: "450.00",
    color: "Silver",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
];
// =================== Special Offer data End here ==============

// =================== PaginationItems Start here ===============

export const paginationItems = [
  {
    category: "Laptops",
    _id: 1001,
    img: spfOne,
    productName: "MSI NB GS65",
    price: "300.00",
    color: "Black and White",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Handphones",
    _id: 1002,
    img: spfTwo,
    productName: "Poco X5",
    price: "150.00",
    color: "Black, Yellow, Blue",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "HeadPhone",
    _id: 1003,
    img: spfThree,
    productName: "Headphones",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Laptops",
    _id: 1004,
    img: spfFour,
    productName: "ROG Zephyrus G14",
    price: "450.00",
    color: "Silver",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Accessories",
    _id: 1005,
    img: bestSellerOne,
    productName: "GeForce GTX-1650",
    price: "320.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Handphones",
    _id: 1006,
    img: bestSellerTwo,
    productName: "Samsung Galaxy",
    price: "240.00",
    color: "Gray",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Kameras",
    _id: 1007,
    img: bestSellerThree,
    productName: "DSLR Nikon DF",
    price: "320.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Laptops",
    _id: 1008,
    img: bestSellerFour,
    productName: "Asus ROG G531gu",
    price: "550.00",
    color: "Black",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Accessories",
    _id: 1009,
    img: newArrOne,
    productName: "Hardisk",
    price: "80.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Accessories",
    _id: 1010,
    img: newArrTwo,
    productName: "SmartWatch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Accessories",
    _id: 1011,
    img: newArrThree,
    productName: "Headset",
    price: "30.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Accessories",
    _id: 1012,
    img: newArrFour,
    productName: "Keyboard",
    price: "60.00",
    color: "Mixed",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Laptops",
    _id: 1013,
    img: spfOne,
    productName: "MSI NB GS65",
    price: "300.00",
    color: "Black",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },

  {
    category: "Accessories",
    _id: 1014,
    img: newArrTwo,
    productName: "SmartWatch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Accessories",
    _id: 1015,
    img: newArrFour,
    productName: "Keyboard",
    price: "80.00",
    color: "Mixed",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Accessories",
    _id: 1016,
    img: newArrTwo,
    productName: "SmartWatch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Laptops",
    _id: 1017,
    img: bestSellerFour,
    productName: "Asus ROG G531gu",
    price: "550.00",
    color: "Black",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Accessories",
    _id: 1018,
    img: newArrOne,
    productName: "Hardisk",
    price: "30.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Accessories",
    _id: 1019,
    img: newArrTwo,
    productName: "SmartWatch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    category: "Accessories",
    _id: 1020,
    img: newArrThree,
    productName: "Headset",
    price: "50.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1021,
    img: spfThree,
    productName: "Headphones",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1022,
    img: spfFour,
    productName: "ROG Zephyrus G14",
    price: "450.00",
    color: "Silver",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1023,
    img: bestSellerOne,
    productName: "GeForce GTX-1650",
    price: "320.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1024,
    img: spfOne,
    productName: "MSI NB GS65",
    price: "300.00",
    color: "Black and White",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1025,
    img: spfTwo,
    productName: "Poco X5",
    price: "150.00",
    color: "Black, Yellow, Blue",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1026,
    img: spfThree,
    productName: "Headphones",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1027,
    img: spfFour,
    productName: "ROG Zephyrus G14",
    price: "450.00",
    color: "Silver",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1028,
    img: bestSellerOne,
    productName: "GeForce GTX-1650",
    price: "320.00",
    color: "Blank and White",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1029,
    img: bestSellerTwo,
    productName: "Samsung Galaxy",
    price: "240.00",
    color: "Gray",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1030,
    img: bestSellerThree,
    productName: "DSLR Nikon DF",
    price: "320.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1031,
    img: bestSellerFour,
    productName: "Asus ROG G531gu",
    price: "550.00",
    color: "Black",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1032,
    img: newArrOne,
    productName: "Hardisk",
    price: "80.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1033,
    img: newArrTwo,
    productName: "SmartWatch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1034,
    img: newArrThree,
    productName: "Headset",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1035,
    img: newArrFour,
    productName: "Keyboard",
    price: "60.00",
    color: "Mixed",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1036,
    img: spfFour,
    productName: "ROG Zephyrus G14",
    price: "450.00",
    color: "Black",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1037,
    img: newArrFour,
    productName: "Keyboard",
    price: "30.00",
    color: "Mixed",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1038,
    img: newArrTwo,
    productName: "SmartWatch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    
    _id: 1039,
    img: bestSellerFour,
    productName: "Asus ROG G531gu",
    price: "550.00",
    color: "Black",
    badge: false,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1040,
    img: newArrOne,
    productName: "Hardisk",
    price: "44.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1041,
    img: newArrTwo,
    productName: "SmartWatch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1042,
    img: newArrThree,
    productName: "Headset",
    price: "30.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1043,
    img: spfThree,
    productName: "Headphones",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1044,
    img: spfFour,
    productName: "ROG Zephyrus G14",
    price: "450.00",
    color: "Silver",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1045,
    img: bestSellerOne,
    productName: "GeForce GTX-1650",
    price: "320.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: 1046,
    img: spfOne,
    productName: "MSI NB GS65",
    price: "300.00",
    color: "Black and White",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
];
// =================== PaginationItems End here =================

export const CategoryData = [
  {
    _id: 1,
    productName: "Laptops",
  },
  {
    _id: 2,
    productName: "Cameras",
  },
  {
    _id: 3,
    productName: "HandPhones",
    
  },
  {
    _id: 4,
    productName: "Accessories",
  },
  {
    _id: 5,
    productName: "Hardisks",
  },
  {
    _id: 6,
    productName: "HeadPhones",
  },
];

export const products = [
  {
      "id": "1",
      "category": "Smartphone",
      "products": [
          {
              "id": "1",
              "name": "iPhone 13",
              "price": 999,
              "image": "https://example.com/iphone13.jpg",
              "specs": {
                  "Screen Size": "6.1 inches",
                  "Processor": "A15 Bionic",
                  "RAM": "4GB",
                  "Storage": "128GB",
                  "Camera": "Dual 12MP",
                  "Operating System": "iOS 15",
                  "Battery Life": "Up to 22 hours of talk time"
              }
          },
          {
              "id": "2",
              "name": "Samsung Galaxy S21",
              "price": 799,
              "image": "https://example.com/samsungs21.jpg",
              "specs": {
                  "Screen Size": "6.2 inches",
                  "Processor": "Exynos 2100",
                  "RAM": "8GB",
                  "Storage": "128GB",
                  "Camera": "Triple 12MP",
                  "Operating System": "Android 11",
                  "Battery Life": "Up to 17 hours of talk time"
              }
          },
          {
              "id": "11",
              "name": "Google Pixel 6",
              "price": 699,
              "image": "https://example.com/googlepixel6.jpg",
              "specs": {
                  "Screen Size": "6.4 inches",
                  "Processor": "Google Tensor",
                  "RAM": "8GB",
                  "Storage": "128GB",
                  "Camera": "Dual 50MP",
                  "Operating System": "Android 12",
                  "Battery Life": "Up to 24 hours of talk time"
              }
          },
          {
              "id": "12",
              "name": "OnePlus 9 Pro",
              "price": 899,
              "image": "https://example.com/oneplus9pro.jpg",
              "specs": {
                  "Screen Size": "6.7 inches",
                  "Processor": "Qualcomm Snapdragon 888",
                  "RAM": "12GB",
                  "Storage": "256GB",
                  "Camera": "Quad 48MP",
                  "Operating System": "OxygenOS based on Android 11",
                  "Battery Life": "Up to 20 hours of talk time"
              }
          }
      ]
  },
  {
      "id": "2",
      "category": "Laptop",
      "products": [
          {
              "id": "3",
              "name": "MacBook Pro",
              "price": 1499,
              "image": "https://example.com/macbookpro.jpg",
              "specs": {
                  "Screen Size": "13.3 inches",
                  "Processor": "Apple M1",
                  "RAM": "8GB",
                  "Storage": "256GB SSD",
                  "Graphics": "Integrated Apple GPU",
                  "Operating System": "macOS Big Sur",
                  "Battery Life": "Up to 17 hours"
              }
          },
          {
              "id": "4",
              "name": "Dell XPS 13",
              "price": 1199,
              "image": "https://example.com/dellxps13.jpg",
              "specs": {
                  "Screen Size": "13.4 inches",
                  "Processor": "Intel Core i7",
                  "RAM": "16GB",
                  "Storage": "512GB SSD",
                  "Graphics": "Intel Iris Xe",
                  "Operating System": "Windows 10",
                  "Battery Life": "Up to 14 hours"
              }
          },
          {
              "id": "13",
              "name": "HP Spectre x360",
              "price": 1299,
              "image": "https://example.com/hpspectrex360.jpg",
              "specs": {
                  "Screen Size": "13.3 inches",
                  "Processor": "Intel Core i7",
                  "RAM": "16GB",
                  "Storage": "512GB SSD",
                  "Graphics": "Intel Iris Xe",
                  "Operating System": "Windows 11",
                  "Battery Life": "Up to 15 hours"
              }
          },
          {
              "id": "14",
              "name": "Asus ZenBook 14",
              "price": 1099,
              "image": "https://example.com/asuszenbook14.jpg",
              "specs": {
                  "Screen Size": "14 inches",
                  "Processor": "AMD Ryzen 7",
                  "RAM": "16GB",
                  "Storage": "1TB SSD",
                  "Graphics": "Integrated AMD Radeon",
                  "Operating System": "Windows 10",
                  "Battery Life": "Up to 12 hours"
              }
          }
      ]
  },
  {
      "id": "3",
      "category": "Headphones",
      "products": [
          {
              "id": "5",
              "name": "Sony WH-1000XM4",
              "price": 349,
              "image": "https://example.com/sonywh1000xm4.jpg",
              "specs": {
                  "Type": "Over-ear, Wireless",
                  "Noise Cancellation": "Active Noise Cancellation",
                  "Battery Life": "Up to 30 hours",
                  "Connectivity": "Bluetooth 5.0",
                  "Special Features": "Touch controls, Voice assistant support"
              }
          },
          {
              "id": "6",
              "name": "Bose QuietComfort 35 II",
              "price": 299,
              "image": "https://example.com/boseqc35ii.jpg",
              "specs": {
                  "Type": "Over-ear, Wireless",
                  "Noise Cancellation": "Active Noise Cancellation",
                  "Battery Life": "Up to 20 hours",
                  "Connectivity": "Bluetooth 4.1",
                  "Special Features": "Google Assistant support"
              }
          },
          {
              "id": "15",
              "name": "Sennheiser HD 800 S",
              "price": 1499,
              "image": "https://example.com/sennheiserhd800s.jpg",
              "specs": {
                  "Type": "Over-ear, Wired",
                  "Noise Cancellation": "Passive Noise Cancellation",
                  "Connectivity": "Wired",
                  "Special Features": "Open-back design"
              }
          },
          {
              "id": "16",
              "name": "Jabra Elite 85t",
              "price": 229,
              "image": "https://example.com/jabraelite85t.jpg",
              "specs": {
                  "Type": "In-ear, True Wireless",
                  "Noise Cancellation": "Active Noise Cancellation",
                  "Battery Life": "Up to 5.5 hours (ANC on), 25 hours with charging case",
                  "Connectivity": "Bluetooth 5.1",
                  "Special Features": "IPX4 water resistance"
              }
          }
      ]
  },
  {
      "id": "4",
      "category": "Television",
      "products": [
          {
              "id": "7",
              "name": "LG OLED65C1PUB",
              "price": 1999,
              "image": "https://example.com/lgoled65c1pub.jpg",
              "specs": {
                  "Screen Size": "65 inches",
                  "Resolution": "4K Ultra HD",
                  "Panel Type": "OLED",
                  "Smart TV Features": "WebOS, AI ThinQ",
                  "HDMI Ports": 4,
                  "Refresh Rate": "120Hz"
              }
          },
          {
              "id": "8",
              "name": "Samsung QN90A",
              "price": 1799,
              "image": "https://example.com/samsungqn90a.jpg",
              "specs": {
                  "Screen Size": "65 inches",
                  "Resolution": "4K Ultra HD",
                  "Panel Type": "QLED",
                  "Smart TV Features": "Tizen, Bixby",
                  "HDMI Ports": 4,
                  "Refresh Rate": "120Hz"
              }
          },
          {
              "id": "17",
              "name": "Sony Bravia XR A90J",
              "price": 2999,
              "image": "https://example.com/sonybraviaxra90j.jpg",
              "specs": {
                  "Screen Size": "65 inches",
                  "Resolution": "4K Ultra HD",
                  "Panel Type": "OLED",
                  "Smart TV Features": "Android TV, Google Assistant",
                  "HDMI Ports": 4,
                  "Refresh Rate": "120Hz"
              }
          },
          {
              "id": "18",
              "name": "TCL 6-Series",
              "price": 899,
              "image": "https://example.com/tcl6series.jpg",
              "specs": {
                  "Screen Size": "55 inches",
                  "Resolution": "4K Ultra HD",
                  "Panel Type": "QLED",
                  "Smart TV Features": "Roku TV, Voice Control",
                  "HDMI Ports": 4,
                  "Refresh Rate": "60Hz"
              }
          }
      ]
  },
  {
      "id": "5",
      "category": "Tablet",
      "products": [
          {
              "id": "9",
              "name": "iPad Air",
              "price": 599,
              "image": "https://example.com/ipadair.jpg",
              "specs": {
                  "Screen Size": "10.9 inches",
                  "Processor": "A14 Bionic",
                  "RAM": "4GB",
                  "Storage": "64GB",
                  "Operating System": "iPadOS 15",
                  "Battery Life": "Up to 10 hours"
              }
          },
          {
              "id": "10",
              "name": "Samsung Galaxy Tab S7+",
              "price": 749,
              "image": "https://example.com/samsungtabs7+.jpg",
              "specs": {
                  "Screen Size": "12.4 inches",
                  "Processor": "Snapdragon 865+",
                  "RAM": "6GB",
                  "Storage": "128GB",
                  "Operating System": "Android 11",
                  "Battery Life": "Up to 14 hours"
              }
          },
          {
              "id": "19",
              "name": "Microsoft Surface Pro 8",
              "price": 1099,
              "image": "https://example.com/microsoftsurfacepro8.jpg",
              "specs": {
                  "Screen Size": "13 inches",
                  "Processor": "11th Gen Intel Core i5",
                  "RAM": "8GB",
                  "Storage": "256GB",
                  "Operating System": "Windows 11",
                  "Battery Life": "Up to 16 hours"
              }
          },
          {
              "id": "20",
              "name": "Amazon Fire HD 10",
              "price": 149,
              "image": "https://example.com/amazonfirehd10.jpg",
              "specs": {
                  "Screen Size": "10.1 inches",
                  "Processor": "Octa-core 2.0 GHz",
                  "RAM": "3GB",
                  "Storage": "32GB",
                  "Operating System": "Fire OS 7",
                  "Battery Life": "Up to 12 hours"
              }
          }
      ],
      "keranjang": [],
      "pesanans": []
  }
]
